export default __webpack_public_path__ + "static/media/map_large.56df8a61.png";